<ng-container *ngIf="options$ | async as options">
    <drop-down
        #dropDown
        [modern]="modern"
        [disabled]="disabled"
        [selectedTemplate]="selectedTemplate"
        [optionsTemplate]="optionsTemplate"
        [expandingMode]="expandingMode"
        (optionsVisibility)="onToggleOptions($event)"
    >
        <ng-template #selectedTemplate>
            <div class="drop-down-option" [ngClass]="{'with-indicator': dropDown.dropIndicator}">
                <ng-container *ngIf="getSelected() as selected">
                    <span *ngIf="useIcons" class="icon-wrapper"><i class="{{ selected.icon }}"></i></span>
                    <ng-container *ngIf="useSvgImage && !useIcons">
                        <svg-image
                            *ngIf="selected.svgImage"
                            [name]="selected.svgImage"
                            [replaceElementOnChanges]="true"
                            class="platform-icon"
                        ></svg-image>
                    </ng-container>
                    <span class="label">{{ selected.label }}</span>
                </ng-container>
            </div>
        </ng-template>
        <ng-template #optionsTemplate>
            <div class="drop-down-list-options">
                <div
                    class="drop-down-toggle"
                    [ngClass]="{'with-indicator': dropDown.dropIndicator}"
                    *ngIf="dropDown.isInsideMode()"
                    (click)="dropDown.toggleContent(false)"
                >
                    <ng-container [ngTemplateOutlet]="selectedTemplate"></ng-container>
                </div>
                <div *ngIf="search" class="search-wrapper">
                    <search-input
                        #searchInput
                        [ngModel]="searchQuery"
                        [placeholder]="searchPlaceholder"
                        (searchInput)="onSearch($event)"
                    ></search-input>
                </div>
                <ng-container *ngIf="filterOptions(options) as filteredOptions">
                    <div #optionsWrapper class="options-wrapper">
                        <div
                            class="drop-down-option"
                            *ngFor="let option of filteredOptions; trackBy: trackByValue"
                            [ngClass]="{selected: isSelected(option), disabled: isDisabled(option)}"
                            (click)="onOptionClick(option)"
                        >
                            <ng-container *ngIf="!optionsListTemplate">
                                <span *ngIf="useIcons" class="icon-wrapper"><i class="{{ option.icon }}"></i></span>
                                <svg-image
                                    *ngIf="useSvgImage && !useIcons"
                                    [name]="option.svgImage"
                                    [replaceElementOnChanges]="true"
                                    class="platform-icon"
                                ></svg-image>
                                <span class="label">{{ option.label }}</span>
                                <span class="selected-mark"></span>
                            </ng-container>
                            <ng-container *ngIf="optionsListTemplate">
                                <ng-container *ngTemplateOutlet="optionsListTemplate; context: {$implicit: option}"></ng-container>
                            </ng-container>
                        </div>
                    </div>
                    <div *ngIf="!filteredOptions.length && search" class="empty-results">{{ noResultsPlaceholder }}</div>
                </ng-container>
            </div>
        </ng-template>
    </drop-down>
</ng-container>
